module.exports = __webpack_public_path__ + "img/美颜首图.8eae0c70.png";